module.exports = __webpack_public_path__ + "static/media/03.739d5563.mp3";